export function fiveMinutesCacheKey() {
    return Math.floor(Date.now() / 5 / 1000 / 60);
}
